import { CompaniesContextType, dispatchTypes, DispatchValue } from "./types";

export const CompaniesReducer = (state: CompaniesContextType, action: any) => {
    const { type, payload } = action
    switch (type) {
        case dispatchTypes.SET_VALUE: {
            const { attr, value } = payload as DispatchValue
            return {
                ...state as unknown as CompaniesContextType,
                [attr]: value
            }
        }
        case dispatchTypes.CLOSE_MODAL: {
            if (payload) {
                const { attr, value } = payload as DispatchValue
                return {
                    ...state as unknown as CompaniesContextType,
                    modalOpen: false,
                    [attr]: value
                }
            }
            return {
                ...state as unknown as CompaniesContextType,
                modalOpen: false,
            }

        }
        case dispatchTypes.OPEN_MODAL: {
            if (payload) {
                const { attr, value } = payload as DispatchValue
                return {
                    ...state as unknown as CompaniesContextType,
                    modalOpen: true,
                    [attr]: value
                }
            }
            return {
                ...state as unknown as CompaniesContextType,
                modalOpen: true,
            }
        }
        default:
            return state
    }
}